var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"form-group\" ng-class=\"{'has-error': hasError()}\">\n<label class=\"control-label\" ng-show=\"showTitle()\">{{form.title}}</label>\n<input ng-if=\"form.readonly\" ng-show=\"form.key\" type=\"text\" placeholder=\"\" class=\"form-control\" id=\"datetime\" value=\"{{model.datetime  | datetime: 'LL'}}\" ng-disabled=\"form.readonly\" name=\"datetime\" disabled=\"disabled\"/>\n<p class=\"input-group\" ng-if=\"!form.readonly\">\n</p><div bb-date-time-picker date-only=\"true\" date=\"$$value$$\"></div>\n<p></p>\n<span class=\"help-block\">{{ (hasError() && errorMessage(schemaError())) || form.description}}</span>\n</div>\n";
var id1="core/-config/schema-form/date_form.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/core/-config/schema-form/date_form.html
// module id = 930
// module chunks = 0